import { LimitDetailTableSchema } from "./LimitDetailSchema";
export class CarAdminLimitDetailSchema extends LimitDetailTableSchema {
    constructor() {
        super({
            objectCondition: {
                isRequired: false
            }
        });
    }
}
//# sourceMappingURL=CarAdminLimitDetailSchema.js.map